import { get } from "./http";

export async function getCommonPutTeamList() {
  const url = "/api/common/put-team-list";
  try {
    const resp = await get(url, {type: 1});
    if (resp.data.code === 200) {
      const result = [];
      const list = resp.data.data.list;
      for (const item of list) {
        result.push({
          label: item.team_name,
          value: item.id,
        });
      }
      return result;
    }
  } catch (err) {
    return [];
  }
  return false;
}
